import { useState, useEffect } from 'react';

interface SyncNotification {
  id: string;
  type: 'success' | 'error' | 'info';
  message: string;
}

export function SyncToast() {
  const [notifications, setNotifications] = useState<SyncNotification[]>([]);

  useEffect(() => {
    if (!('serviceWorker' in navigator)) {
      return;
    }

    const handleSWMessage = (event: MessageEvent) => {
      if (event.data.type === 'SYNC_SUCCESS') {
        const id = Math.random().toString(36);
        setNotifications((prev) => [
          ...prev,
          {
            id,
            type: 'success',
            message: 'Offline changes synced successfully',
          },
        ]);

        setTimeout(() => {
          setNotifications((prev) => prev.filter((n) => n.id !== id));
        }, 3000);
      }
    };

    navigator.serviceWorker.addEventListener('message', handleSWMessage);

    return () => {
      navigator.serviceWorker.removeEventListener('message', handleSWMessage);
    };
  }, []);

  return (
    <div className="fixed bottom-4 right-4 z-40 space-y-2">
      {notifications.map((notification) => (
        <div
          key={notification.id}
          className={`rounded-lg shadow-lg px-4 py-3 text-sm text-white max-w-xs ${
            notification.type === 'success'
              ? 'bg-green-500'
              : notification.type === 'error'
                ? 'bg-red-500'
                : 'bg-blue-500'
          }`}
        >
          {notification.message}
        </div>
      ))}
    </div>
  );
}
